import { getFolder } from '@/utils/general';
export default {
  methods: {
    async onItemDrop(dropEvent, targetFolder = { _id: 'my-stuff' }) {
      if (!dropEvent.data) {
        return;
      }
      const dropedItem = dropEvent.data;
      const isDocument = (dropedItem.type && dropedItem.size) || false;
      let targetFolderData;
      // Check if droped item has been droped in the same container.
      if (dropedItem._id === targetFolder._id) {
        return;
      }
      if (targetFolder._id === 'my-stuff') {
        targetFolderData = {
          level: 0,
          folder: {
            ...this.mainFolder,
            folders: this.folders
          }
        };
      } else if (targetFolder._id === 'team') {
        targetFolderData = {
          level: 0,
          folder: {
            ...this.teamMainFolder,
            folders: this.teamFolders
          }
        };
      } else {
        targetFolderData = getFolder(this.folders, targetFolder._id);
        if (targetFolderData.folder === null) {
          targetFolderData = getFolder(this.teamFolders, targetFolder._id);
        }
      }
      if (!isDocument) {
        // Check if droped folder already exist in target folder.
        const exist = targetFolderData.folder?.folders?.some(
          f => f._id === dropedItem._id
        );
        if (exist) {
          return;
        }
        if (
          targetFolderData.level >= 2 ||
          (dropedItem.folders.length && targetFolderData.level === 1)
        ) {
          // A folder cannot be a third level or folder with subfolders cannot be nested in level 1.
          this.$notify({
            group: 'alert',
            title: 'FAILED!',
            text: `We were unable to move folder into ${targetFolder.name}.`,
            type: 'error'
          });
          return;
        }
        this.documentsReady = false;
        const params = {
          id: dropedItem._id,
          name: dropedItem.name,
          parent: targetFolder._id
        };
        await this.updateFolder(params);
        // Get the documents in the current folder
        this.$nextTick(async () => {
          if (this.getDocuments) {
            // The inner Folders and Documents components may not have the function.
            await this.getDocuments();
          }
          this.documentsReady = true;
        });
        return;
      }
      // Check if droped file already exist in target folder.
      const exist = targetFolderData.folder?.documents?.some(
        d => d._id === dropedItem._id
      );
      if (exist) {
        return;
      }
      let oldFolder;
      if (dropedItem.folder) {
        oldFolder = dropedItem.folder;
      } else {
        oldFolder = dropedItem.isShared ? 'team' : 'my-stuff';
      }
      const params = {
        oldFolder,
        newFolder: targetFolder._id,
        isShared: targetFolder.isShared || false
      };
      await this.updateDocument({ id: dropedItem._id, params });
    }
  }
};
